import React, { Component } from "react";
import uploadPicture from "../assets/uploadPicture.svg";
export default class PictureUpload extends Component {
  preview = React.createRef();
  previewFile = (event) => {
    var preview = this.preview.current;
    var file = event.currentTarget.files[0];
    var reader = new FileReader();
    reader.onload = () => {
      //  
      //  
      //  
    };

    reader.onloadend = function () {
      preview.style.backgroundImage = `url("${reader.result}")`;
    };

    if (file) {
      reader.readAsDataURL(file);
    } else {
      //   preview.src = "";
    }
  };
  render() {
    return (
      <div className="flex center uploadPicture">
        <input
          type="file"
          accept="image/*"
          onChange={this.previewFile}
          name={this.props.name}
          id=""
        />
        <span
          className="dp-rapper"
          style={{
            backgroundImage: `url("${this.props.defaultsrc || uploadPicture}")`,
          }}
          ref={this.preview}
        >
          {/* <img src={uploadPicture} ref={this.preview} alt="" srcSet="" /> */}
        </span>
        <div>
          <p className="title">
            Tap here to add a {this.props.title ? this.props.title : "picture"}
          </p>
          <p className="small">
            {this.props.description
              ? this.props.description
              : "Adding a picture makes it easier to recognize you"}
          </p>
        </div>
      </div>
    );
  }
}
